import React from "react";

const WorkCard = ({ data }) => {
    return (
        <div className="bg-black/70 border border-yellow-500 text-white p-3 rounded-xl flex flex-col justify-between">
            <div>
                <h2 className="text-2xl font-bold">{data.title}</h2>
                <p className="mt-2 text-lg">{data.description}</p>
            </div>
            {/* <p className="text-sm opacity-75 uppercase">{data.category}</p> */}
            {/* <a href={`https://${data.link}`} target="_blank" rel="noopener noreferrer" className="mt-2 inline-block text-teal-300">
                {data.link}
            </a> */}
            {/* <div className="flex gap-3 mt-4">
                {data.technologies.map((tech, index) => (
                    <span key={index} className="text-gray-300 text-sm bg-gray-700 px-2 py-1 rounded-full">
                        {tech}
                    </span>
                ))}
            </div> */}
            <div className="mt-5 px-3">
                <img src={data.image} alt={data.title} className="w-full h-[500px] rounded-lg" />
            </div>
        </div>
    );
};

export default WorkCard;
